<template>
  <div class="theme-selector">
    <div class="row g-2">
      <div
        v-for="tema in temas"
        :key="tema.clave"
        class="col-6 col-md-4"
        @click="$emit('update:modelValue', tema.clave)"
      >
        <div
          class="theme-card"
          :class="{ 'theme-card--selected': modelValue === tema.clave }"
          :style="{ background: tema.fondo, borderColor: modelValue === tema.clave ? tema.acento : 'transparent' }"
        >
          <div class="theme-card__preview">
            <div class="theme-card__titulo" :style="{ color: tema.texto }">{{ tema.nombre }}</div>
            <div class="theme-card__producto" :style="{ background: tema.tarjeta }">
              <div class="theme-card__precio" :style="{ color: tema.texto2 }">19,90 €</div>
              <div class="theme-card__boton" :style="{ background: tema.acento }">Comprar</div>
            </div>
          </div>
          <div v-if="modelValue === tema.clave" class="theme-card__check">✓</div>
        </div>
        <div class="theme-card__label">{{ tema.nombre }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PasarelaThemeSelector",
  props: {
    modelValue: { type: String, default: "azul_quanty" },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      temas: [
        {
          clave: "verde_pro",
          nombre: "Verde Pro",
          fondo: "#1a2e1a",
          tarjeta: "#253825",
          acento: "#4caf50",
          texto: "#e8f5e9",
          texto2: "#c8e6c9",
        },
        {
          clave: "dark_premium",
          nombre: "Dark Premium",
          fondo: "#0d0d0d",
          tarjeta: "#1a1a2e",
          acento: "#ffd700",
          texto: "#ffffff",
          texto2: "#e0e0e0",
        },
        {
          clave: "azul_quanty",
          nombre: "Azul Quanty",
          fondo: "#0a1628",
          tarjeta: "#112240",
          acento: "#00b4d8",
          texto: "#ffffff",
          texto2: "#caf0f8",
        },
        {
          clave: "claro_deportivo",
          nombre: "Claro Deportivo",
          fondo: "#f5f7fa",
          tarjeta: "#ffffff",
          acento: "#1976d2",
          texto: "#1a1a1a",
          texto2: "#424242",
        },
        {
          clave: "rojo_energia",
          nombre: "Rojo Energía",
          fondo: "#1a0a0a",
          tarjeta: "#2d1010",
          acento: "#f44336",
          texto: "#ffffff",
          texto2: "#ffcdd2",
        },
        {
          clave: "violeta_vip",
          nombre: "Violeta VIP",
          fondo: "#1a0a2e",
          tarjeta: "#2d1058",
          acento: "#ab47bc",
          texto: "#ffffff",
          texto2: "#e1bee7",
        },
      ],
    };
  },
};
</script>

<style scoped>
.theme-card {
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  transition: border-color 0.2s, transform 0.1s;
  position: relative;
}
.theme-card:hover {
  transform: translateY(-2px);
}
.theme-card--selected {
  border-width: 2px;
}
.theme-card__preview {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.theme-card__titulo {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.theme-card__producto {
  border-radius: 6px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.theme-card__precio {
  font-size: 10px;
  font-weight: 600;
}
.theme-card__boton {
  font-size: 9px;
  padding: 3px 7px;
  border-radius: 4px;
  color: #fff;
  font-weight: 700;
}
.theme-card__check {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 14px;
  color: #fff;
  font-weight: 900;
  text-shadow: 0 1px 3px rgba(0,0,0,0.5);
}
.theme-card__label {
  text-align: center;
  font-size: 11px;
  margin-top: 4px;
  font-weight: 600;
  color: var(--q-muted);
}
</style>
